module.exports = __webpack_public_path__ + "img/normal-big.b9ace144.svg";